document.addEventListener("DOMContentLoaded", function () {
  class OfferDetails extends HTMLElement {
    #namespace = "c-offer-details";
    #animation = null;
    #boundHandleClose;
    #boundHandleToggle;
    #boundHandleResize;
    #active = false;
    #expanded = false;
    constructor() {
      super();
      this.close = this.querySelector(`.${this.#namespace}__close`);
      this.toggle = this.querySelector(`.${this.#namespace}__toggle`);
      this.panel = this.querySelector(`.${this.#namespace}__panel`);
      if (this.toggle === null || this.panel === null) return;
      this.#boundHandleClose = this.#handleClose.bind(this);
      this.#boundHandleToggle = this.#handleToggle.bind(this);
      this.#boundHandleResize = this.#handleResize.bind(this);
      this.close.addEventListener("click", this.#boundHandleClose);
      this.toggle.addEventListener("click", this.#boundHandleToggle);
    }
    connectedCallback() {
      window.addEventListener("resize", this.#boundHandleResize);
      this.#handleResize();
    }
    disconnectedCallback() {
      window.removeEventListener("resize", this.#boundHandleResize);
    }
    #handleResize() {
      if (window.innerWidth < 992) {
        this.#active = true;
        return;
      }
      if (this.#animation) {
        this.#animation.cancel();
      }
      if (this.#active) {
        document.body.style.overflow = "";
        this.panel.removeAttribute("style");
        this.#active = false;
        this.#expanded = false;
      }
    }
    #handleClose(event) {
      event.preventDefault();
      if (this.#animation) {
        this.#animation.cancel();
      }
      this.#expanded = false;
      this.#collapse();
    }
    #handleToggle(event) {
      event.preventDefault();
      if (this.#animation) {
        this.#animation.cancel();
      }
      this.#expanded = !this.#expanded;
      if (this.#expanded) {
        this.#expand();
      } else {
        this.#collapse();
      }
    }
    #expand() {
      document.body.style.overflow = "hidden";
      this.panel.style.visibility = "visible";
      this.#animation = this.#animate({
        opacity: [0, 1],
        transform: ["translateY(16px)", "translateY(0)"]
      });
    }
    #collapse() {
      this.#animation = this.#animate({
        opacity: [1, 0],
        transform: ["translateY(0)", "translateY(16px)"]
      });
      this.#animation.onfinish = () => {
        document.body.style.overflow = "";
        this.panel.style.visibility = "hidden";
      };
    }
    #animate({
      opacity,
      transform
    }) {
      return this.panel.animate({
        opacity,
        transform
      }, {
        duration: 300,
        easing: "ease-in-out",
        fill: "both"
      });
    }
  }
  customElements.define("offer-details", OfferDetails);
});